global.debug = false;
global.statusConexao = navigator.onLine;

global.url = process.env.REACT_APP_API || "https://api.wavecode.com.br/"